import React, { useState, useEffect } from "react";
import { DatePicker, Radio, Tag } from "antd";
import ReportApi from "@api/report";
import Title from "@/components/Title";
import Analysisapi from "@/api/analysis";
import moment from "moment";
import Area from "@/components/twoarea";
import Charts from "./echart.js";
import Ocharts from "./ochart.js";
import "./../style.scss";
import "./style.css";
const { RangePicker } = DatePicker;
export default ({ history }) => {
  const date = new Date();
  const Year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  var clock = Year + "-";
  var clock1 = Year + "-";
  if (month < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += month + "-";
  clock1 += month + "-";
  if (day < 10) {
    clock += "0";
    clock1 += "0";
  }
  clock += day + " ";
  clock1 += day + 1 + " ";
  const [data, setData] = useState({
    data: [],
    avg: {},
  });
  const [InData, setInData] = useState({
    data: [],
    avg: {},
  });
  const [biochemical, setBiochemical] = useState({
    data: [],
    avg: {},
  });
  const [station, setStation] = useState([]);
  const [stationId, setStationId] = useState();
  const [stationTwoId, setStationTwoId] = useState();
  const [stationThreeId, setStationThreeId] = useState();
  const [defaultDate, setDefaultDate] = useState();
  const [defaultTwoDate, setDefaultTwoDate] = useState();
  const [threeDefaultDate, setThreeDefaultDate] = useState();
  const [searchParams, setSearchParams] = useState({
    queryTimeStartStr: clock + "00:00:00",
    queryTimeEndStr: clock1 + "00:00:00",
    reportType: 1,
    inOrOut: 2,
    cod: 1,
    nh3n: 3,
    tn: 2,
    tp: 4,
    ss: 7,
    stationId: stationId,
  });
  const [twoSearchParams, setTwoSearchParams] = useState({
    queryTimeStartStr: clock + "00:00:00",
    queryTimeEndStr: clock1 + "00:00:00",
    reportType: 1,
    inOrOut: 1,
    cod: 1,
    nh3n: 3,
    tn: 2,
    tp: 4,
    ss: 7,
    stationId: stationTwoId,
  });
  const [threeSearchParams, setThreeSearchParams] = useState({
    queryTimeStartStr: clock + "00:00:00",
    queryTimeEndStr: clock1 + "00:00:00",
    reportType: 1,
    inOrOut: 1,
    cod: 1,
    nh3n: 3,
    tn: 2,
    tp: 4,
    ss: 7,
    stationId: stationThreeId,
  });

  useEffect(() => {
    if (stationId) {
      findOutWaterQuality();
    }
  }, [searchParams]);

  useEffect(() => {
    if (stationTwoId) {
      findInWaterQuality();
    }
  }, [twoSearchParams]);

  useEffect(() => {
    getStation();
  }, []);

  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
        const id = res.data[0] ? res.data[0].id : -1;
        setStationId(id);
        setStationTwoId(id);
        setSearchParams({ ...searchParams, stationId: id });
        setTwoSearchParams({ ...twoSearchParams, stationId: id });
      }
    });
  };
  const getStationId = (id, tag) => {
    if (tag == 1) {
      setSearchParams({
        ...searchParams,
        stationId: id,
      });
      setStationId(id);
    }
    if (tag == 2) {
      setTwoSearchParams({
        ...twoSearchParams,
        stationId: id,
      });
      setStationTwoId(id);
    }
    if (tag == 3) {
      setThreeSearchParams({
        ...threeSearchParams,
        stationId: id,
      });
      setStationThreeId(id);
    }
  };
  const findOutWaterQuality = () => {
    let data = { ...searchParams, stationId: stationId };
    if (data.reportType == 1) {
      data.queryTimeEndStr =
        moment(new Date()).format("YYYY-MM-DD ") + "23:59:59";
    }
    ReportApi.selectWaterQuality(data).then((res) => {
      if (res.status == 0 && res.data) {
        const { data, avg } = res.data;
        setData({
          data: data || [],
          avg: avg || {},
        });
      }
    });
  };
  const findInWaterQuality = () => {
    let data = { ...twoSearchParams, stationId: stationTwoId };
    if (data.reportType == 1) {
      data.queryTimeEndStr =
        moment(new Date()).format("YYYY-MM-DD ") + "23:59:59";
    }
    ReportApi.selectWaterQuality(data).then((res) => {
      if (res.status == 0 && res.data) {
        const { data, avg } = res.data;
        setInData({
          data: data || [],
          avg: avg || {},
        });
      }
    });
  };
  //时间查询
  const DateQuery = (obj, tag) => {
    if (tag == 1) {
      setDefaultDate(obj);
      const startTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const endTime = moment(obj[1]).format("YYYY-MM-DD") + " 00:00:00";
      setSearchParams({
        ...searchParams,
        queryTimeStartStr: startTime,
        queryTimeEndStr: endTime,
      });
    }
    if (tag == 2) {
      setDefaultTwoDate(obj);
      const astartTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const aendTime = moment(obj[1]).format("YYYY-MM-DD") + " 00:00:00";
      setTwoSearchParams({
        ...twoSearchParams,
        queryTimeStartStr: astartTime,
        queryTimeEndStr: aendTime,
      });
    }
    if (tag == 3) {
      setThreeDefaultDate(obj);
      const bstartTime = moment(obj[0]).format("YYYY-MM-DD") + " 00:00:00";
      const bendTime = moment(obj[1]).format("YYYY-MM-DD") + " 23:59:59";
      setThreeSearchParams({
        ...threeSearchParams,
        queryTimeStartStr: bstartTime,
        queryTimeEndStr: bendTime,
      });
    }
  };
  //年月日查询
  const slotQuery = (obj, tag) => {
    let firstDate = "";
    let endDate = "";
    if (month < 10) {
      firstDate = Year + "-" + "0" + month + "-01";
    } else {
      firstDate = Year + "-" + month + "-01";
    }
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let lastTime = new Date(nextMonthFirstDay - oneDay);
    let cmonth = parseInt(lastTime.getMonth() + 1);
    let cday = lastTime.getDate();
    if (cmonth < 10) {
      cmonth = "0" + cmonth;
    }
    if (cday < 10) {
      cday = "0" + cday;
    }
    endDate = date.getFullYear() + "-" + cmonth + "-" + cday;
    const bstartTime = moment(firstDate).format("YYYY-MM-DD") + " 00:00:00";
    const bendTime = moment(endDate).format("YYYY-MM-DD") + " 23:59:59";

    let firstDay = new Date();
    firstDay.setDate(1);
    firstDay.setMonth(0);
    let lastDay = new Date();
    lastDay.setFullYear(lastDay.getFullYear() + 1);
    lastDay.setDate(31);
    lastDay.setMonth(-1);
    firstDay = moment(firstDay).format("YYYY-MM-DD") + " 00:00:00";
    lastDay = moment(lastDay).format("YYYY-MM-DD") + " 23:59:59";

    if (tag == 1) {
      setDefaultDate(null);
      if (obj.target.value == "day") {
        setSearchParams({
          ...searchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setSearchParams({
          ...searchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
    if (tag == 2) {
      setDefaultTwoDate(null);
      if (obj.target.value == "day") {
        setTwoSearchParams({
          ...twoSearchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setTwoSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setTwoSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }

    if (tag == 3) {
      setDefaultTwoDate(null);
      if (obj.target.value == "day") {
        setThreeSearchParams({
          ...twoSearchParams,
          queryTimeStartStr: clock + "00:00:00",
          queryTimeEndStr: clock1 + "00:00:00",
          reportType: 1,
        });
      }
      if (obj.target.value == "month") {
        setThreeSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: bstartTime,
          queryTimeEndStr: bendTime,
        });
      }
      if (obj.target.value == "year") {
        setThreeSearchParams({
          ...twoSearchParams,
          reportType: 2,
          queryTimeStartStr: firstDay,
          queryTimeEndStr: lastDay,
        });
      }
    }
  };

  return (
    <div className="baseContent quality">
      <div className="column" style={{ position: "relative" }}>
        <Title title="出水水质分析"></Title>
        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={(e) => getStationId(e, 1)} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={defaultDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 1);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 1);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        {/* <div style={{ marginTop: 10, paddingLeft: 18 }}>
          <Tag color="#73A0FA">COD平均值{data.avg[101]}</Tag>
          <Tag color="#73DEB3">TN平均值{data.avg[102]}</Tag>
          <Tag color="#9013FE">NH3_N平均值{data.avg[103]}</Tag>
          <Tag color="#FFB761">TP平均值{data.avg[104]}</Tag>
        </div> */}
        <Ocharts data={data} />
      </div>

      <div className="column" style={{ position: "relative" }}>
        <Title title="进水水质分析"></Title>
        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={(e) => getStationId(e, 2)} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={defaultTwoDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 2);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 2);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        {/* <div style={{ marginTop: 10, paddingLeft: 18 }}>
          <Tag color="#73A0FA">COD平均值{InData.avg[101]}</Tag>
          <Tag color="#73DEB3">TN平均值{InData.avg[102]}</Tag>
          <Tag color="#9013FE">NH3_N平均值{InData.avg[103]}</Tag>
          <Tag color="#FFB761">TP平均值{InData.avg[104]}</Tag>
        </div> */}
        <Charts InData={InData} />
      </div>

      <div className="column" style={{ position: "relative" }}>
        <Title title="生化池分析"></Title>
        <div className="area">
          <span
            style={{
              position: "absolute",
              marginLeft: "18px",
              borderBottom: "1px solid #EEF0F3",
              padding: "11px 15px 12px 5px",
              zIndex: "999",
            }}
          >
            厂站:
          </span>
          <Area station={station} getStationId={(e) => getStationId(e, 3)} />
          <div className="solid"></div>
          <div className="tdate">
            时间：
            <RangePicker
              value={threeDefaultDate}
              allowClear={false}
              onChange={(e) => {
                DateQuery(e, 3);
              }}
              style={{ width: "220px" }}
            />
          </div>
        </div>
        <Radio.Group
          onChange={(e) => {
            slotQuery(e, 3);
          }}
          className="button"
          style={{ position: "absolute", width: "200px" }}
        >
          <Radio.Button className="button-children" value="day">
            日
          </Radio.Button>
          <Radio.Button className="button-children" value="month">
            月
          </Radio.Button>
          <Radio.Button className="button-children" value="year">
            年
          </Radio.Button>
        </Radio.Group>
        {/* <Charts InData={biochemical} /> */}
      </div>
    </div>
  );
};
